/*
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-09 10:04:21
 * @LastEditTime: 2019-08-14 15:39:30
 * @LastEditors: Please set LastEditors
 */
import {api} from './../api/api'

/** 省份列表查询 */
const getProList = params => api('user/getProvinceList', params)

/** 市级列表查询 */
const getCtyList = params => api('user/getCityList', params)
/** 获取jsticket */
const getJsticket = params => api('wechat/getJsticket', params)

/** 获取活动信息 */
const getActivityInfo = params => api('activity/getActivityInfo', params)

/** 微信分享上报 */
const shareStatistics = params => api('user/shareStatistics', params)

/** 获取助考之星url */
const getZhuKaoUrl = params => api('content/getZhuKaoUrl', params)

export {
  getProList,
  getCtyList,  
  getJsticket,
  getActivityInfo,
  shareStatistics,
  getZhuKaoUrl
}



// WEBPACK FOOTER //
// ./src/server/common/common.js